import style from './ServicesItem.module.css';
import { useState } from 'react';

const ServicesItem = ({ data }) => {
  return (
    <div className={style.gradientContainer}>
      <div className={style.servicesItem}>
        <h1>{data.title}</h1>
        <div className={style.descriptionContainer}>
          {data.descriptionList.map((item, i) => {
            return <p key={i}>{item}</p>;
          })}
        </div>
        <a href="#contact">
          <button className={style.contactUs}>Contact us</button>
        </a>
      </div>
    </div>
  );
};

export default ServicesItem;
